import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import MGAConfigPage from '@/pages/MGAConfigPage';
import MARSPage from '@/pages/MARSPage';
import AIOperationsPage from '@/pages/AIOperationsPage';
import DataQualityPage from '@/pages/DataQualityPage';
import EnrichmentPage from '@/pages/EnrichmentPage';
import CorporateGroupsPage from '@/pages/CorporateGroupsPage';
import EmailPipelinePage from '@/pages/EmailPipelinePage';
import EmailLogPage from '@/pages/EmailLogPage';
import SystemHealthPage from '@/pages/SystemHealthPage';
import AccessControlPage from '@/pages/AccessControlPage';
import SimulationPage from '@/pages/SimulationPage';
import AriaEscalationSettingsPage from '@/pages/AriaEscalationSettingsPage';
import TenantsPage from '@/pages/TenantsPage';
import AiAuditPage from '@/pages/AiAuditPage';
import AgentRegistryPage from '@/pages/AgentRegistryPage';

export default function AdminModule() {
  const tabs = [
    { id: 'config', label: 'Config', content: <MGAConfigPage /> },
    { id: 'tenants', label: 'Tenants', content: <TenantsPage /> },
    { id: 'aria-claims', label: 'ARIA Claims', content: <AriaEscalationSettingsPage /> },
    { id: 'mars', label: 'MARS', content: <MARSPage /> },
    { id: 'agents', label: 'Agent Registry', content: <AgentRegistryPage /> },
    { id: 'ai-ops', label: 'AI Ops', content: <AIOperationsPage /> },
    { id: 'data-quality', label: 'Data Quality', content: <DataQualityPage /> },
    { id: 'enrichment', label: 'Enrichment', content: <EnrichmentPage /> },
    { id: 'corp-groups', label: 'Corp Groups', content: <CorporateGroupsPage /> },
    { id: 'email', label: 'Email Pipeline', content: <EmailPipelinePage /> },
    { id: 'email-log', label: 'Email Log', content: <EmailLogPage /> },
    { id: 'simulation', label: 'Simulation', content: <SimulationPage /> },
    { id: 'system-health', label: 'System Health', content: <SystemHealthPage /> },
    { id: 'ai-audit', label: 'AI Audit', content: <AiAuditPage /> },
    { id: 'access-control', label: 'Access Control', content: <AccessControlPage /> },
  ];

  return (
    <ModuleShell title="Admin" subtitle="Platform configuration and operations" tabs={tabs} />
  );
}
